import React from "react";
import "../projects/ProjectCard.css";

function ProjectCard({ title, description, imageUrl, tags, link, status }) {
  return (
    <article className="project-item">
      <div className="project-item__media">
        <img src={imageUrl} alt={title} className="project-image" />
      </div>

      <div className="project-item__text">
        <div className="project-item__topline">
          <span className="project-status">{status}</span>
        </div>
        <h2>{title}</h2>
        {description && <p className="project-description">{description}</p>}
        <div className="tags">
          {tags.map((tag) => (
            <span key={tag} className="tag">
              {tag}
            </span>
          ))}
        </div>
        <div className="project-links">
          <a href={link} target="_blank" rel="noopener noreferrer">
            View project
          </a>
        </div>
      </div>
    </article>
  );
}

export default ProjectCard;
